import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../apis/api';

import Loader from '../components/Loader';
import CardLoader from '../components/CardLoader';
import { newcss } from '../components/cardlodercss';

import style from './style/Checkout.module.css';
import Checkoutcart from '../components/Checkoutcart';


const Checkout = () => {
    const history = useHistory();
    const location = useLocation();
    // console.log(location.state);
    const [cart,setCart] = useState([]);
    const [price,setAmount] = useState(0);
    const [dprice,setDamount] = useState(0);
    const [loader,setloader] = useState(false);
    const [sizeList,setSizeList] = useState([]);
    const [defaultAdress,setDefaultAdd] = useState([]);
    const [input,setinput] = useState({name:'',phone:'',address:''});
    const [radio,setradio] = useState({});
    // console.log(location.state);
    // console.log(location.state.size);
    // console.log(location.state.id);
    if(location.state !== null && location.state !== undefined){
        let size = location.state.size;
        let id = location.state.id;
        let counter = 0;

        if(sizeList.length>0){
            sizeList.forEach(val=>{
                if(val.id === id){
                    val.size = size;
                }else{
                    counter++;
                }
            });

            if(counter === sizeList.length){
                let obj = {
                    id:id,size:size
                }
                setSizeList(old=>[...old, obj]);
            }
            
            // console.log(filterdata);
        }else{
            let obj = {
                id:id,size:size
            }
            setSizeList(old=>[...old, obj]);
        }
        // setSizeList(old=> [ ...old , location.state]);
        // setSize(location.state);
    }
    
    // console.log(sizeList);

    const getData = useCallback( async () =>{
        setloader(false);
        
        try {
            const response = await api.get('/checkout');

            const res = await response.data;
            
            const newarr = [];
            const arr= [];
            let amount = 0;let damount = 0;
            res.cart.forEach(prod=>{
                res.products.forEach(val=>{
                    if(prod === val._id){
                        newarr.push(val);
                        // console.log(val);
                        amount = amount+val.amount;
                        damount = damount+val.discountAmount;
                        // console.log('amount is '+amount);
                        // console.log('disamount is '+damount);
                    }
                });
            });

            res.address.map(val=>{
                let obj = {
                    name:val.name,phone:val.phone,address:val.address
                }
                arr.push(obj);
                return null;
            });

            setDefaultAdd(arr.slice(-3));
            setCart(newarr);
            setAmount(amount);
            setDamount(damount);
            setloader(true);

        } catch (error) {
            console.log(error);
        }
    },[]);

    const HandelAcc = () =>{
        let panel = document.getElementById('panel');
        let icon = document.getElementById('fa');
        if(panel.style.display === 'none'){
            panel.style.display = 'block';
            icon.classList.remove('fa-plus');
            icon.classList.add('fa-minus');
        }else{
            panel.style.display = 'none';
            icon.classList.remove('fa-minus');
            icon.classList.add('fa-plus');
        }

    }

    const placeOrder = async () =>{
        let {name,phone,address} = radio;

        
        if(Object.keys(radio).length === 0){
            window.alert('Plz select an address to continue')
        }else{
            console.log(radio);
            console.log(sizeList);
            let fullAddress = name.toString()+' '+phone.toString()+' '+address.toString();
            history.push('/placeorder',{order:sizeList,address:fullAddress,totalAmount:dprice+40});
        }
        // console.log(fullAddress);
        // try {
        //     const response = await api.post('/placeorder',{
        //         order:sizeList,
        //         address:fullAddress,
        //     });
        //     const data = await response.data;
        //     console.log(data);
        //     history.push('/placeorder');
        // } catch (error) {
        //     console.log(error);
        // }
    }

    const delivery = async (e) =>{
        e.preventDefault();

        const response = await api.post('/addAddress',{
            name:input.name,
            phone:input.phone,
            address:input.address
        });

        const data = await response.data;

        let newarr = [];

        data.address.map(val=>{
            let obj = {
                name:val.name,phone:val.phone,address:val.address
            }
            newarr.push(obj);
            return null;
        });
        setDefaultAdd(newarr.slice(-3));
        window.location.reload();
    }

    useEffect(()=>{
        getData();
    },[getData])

    
    return (
        <>
         {loader ? 
        <div className={style.body}>
            <section className={style.checkout}>
                <div className={style.left}>
                    <div className={style.delivery}>
                        <h1 className={style.heading_checkout}>Select Delivery Address</h1>
                                {
                                    defaultAdress.length > 0 ? 
                                    defaultAdress.map((val,index)=>{
                                        return(
                                            <>
                                              <div className={style.address}>
                                              <input type="radio" name="address" value={index} className="radio" onClick={e=>setradio(val)}/>
                                              <div className={style.text}>
                                              <h3>{val.name}<span> {val.phone}</span></h3>
                                              <p>{val.address}</p>
                                              </div>
                                              </div>
                                            </>
                                        )
                                    })
                                    
                                    : <h3>Add delivery Address</h3>
                                }
            
                          
                    </div>
        
                    <button className={style.accordion} onClick={HandelAcc}><i id="fa" className="fa fa-plus" aria-hidden="true"></i><span style={{marginLeft:'20px'}}>Add new Address</span></button>
                    <div className={style.panel} id="panel">
                        <form>
                        <div className={style.formlabel}>
                            <label htmlFor="name">Name:-</label>
                            <input type="text" name="name" placeholder="Enter your name" value={input.name} onChange={(e)=>setinput({...input,name:e.target.value})} />
                            <label htmlFor="phone">Phone No:-</label>
                            <input type="tel" name="phone" placeholder="Enter your Phoneno" value={input.phone} onChange={(e)=>setinput({...input,phone:e.target.value})} />
                        </div>
                        <div className={style.formlabel}>
                            <label htmlFor="name">Address:-</label><br />
                            <textarea name="address" value={input.address} onChange={(e)=>setinput({...input,address:e.target.value})} ></textarea>
                        </div>
                        <button onClick={delivery} style={{padding:'8px',backgroundColor:'green',color:'white',cursor:'pointer' ,margin:'3px 20px'}}>Delivery Here</button>
                        </form>
                    </div>
                   
                    <div className={style.ordersummary}>
                        <h1 className={style.heading_checkout}>Order Summary</h1>
                        <div className={style.products_in_cart}>
                           {loader? cart.length>0?
                              cart.map((val,index)=>{
                                return(
                                    <Checkoutcart  productName={val.productName} colorOption={val.colorOption} discountAmount={val.discountAmount} amount={val.amount} contentType={val.productImage.contentType} imageBase64={val.productImage.imageBase64} size={val.size} index={index} _id={val._id}/>
                                )
                               }) : <p style={{textAlign:'center',fontSize:'1.2rem'}}>No Products Found in your cart</p>:<Loader/>}
                        </div>
                    </div>
                    <div className="paymentoption">
                         {console.log("newsize list is "+sizeList)}
                    </div>
                </div>
                <div className="footer">

                </div>
            </section>
            <section className={style.pricingdetails}>
                <h1 style={{color:'white',border:'2px solid grey',padding:'10px',textAlign:'center',backgroundColor:'darkblue',width:'100%'}}>Pricing Details</h1>
                <table>
                    <tbody>
                    <tr>
                        <td>Price</td>
                        <td>₹ {price}</td>
                    </tr>
                    <tr>
                        <td>Discount</td>
                        <td>₹ -{price-dprice}</td>
                    </tr>
                    <tr>
                        <td>Delivery Charge</td>
                        <td>₹ 40</td>
                    </tr>
                    <tr>
                        <td>Total Amount</td>
                        <td>₹ {dprice+40}</td>
                    </tr>
                    <tr>
                        <td colSpan="2" style={{color:'green',fontSize:'1rem',fontWeight:'bold'}}>you are saving {price-dprice} in this purchacse</td>
                    </tr>
                    </tbody>
                </table>
                <button onClick={placeOrder} className={style.placeorder}>Place Order</button>
            </section>
        </div>
        : <CardLoader style={newcss.loderbox}/> }
        </>
    )
}

export default Checkout;
